
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  const { isAuthenticatedUser, loading } = useSelector(
    (state) => state.userReducer
  );

  // Wait until auth state is known
  if (loading) return null;

  if (!isAuthenticatedUser) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;